export function convertStatus(status: number) {
  if (status < 0 || status >= 3) return '';
  const strings = ['awaiting', 'delivering', 'delivered'];
  return strings[status];
}